import type { NoteEditorComposeState } from './components/NoteEditor/types';

interface ComposeEntry {
  compose?: NoteEditorComposeState;
  pending: boolean;
  completed?: boolean;
}

// Files remain in memory while navigating inside the app; they are never serialized.
const entries = new Map<string, ComposeEntry>();
const latest = new Map<string, number | null>();
const listeners = new Map<string, Set<() => void>>();
export const mobileComposeKey = (scope: string, historyId: number | null) => `${scope}:${historyId ?? 'new'}`;
export const getMobileCompose = (key: string) => entries.get(key);
export const getLastMobileReply = (scope: string) => latest.get(scope) ?? null;
export const updateMobileCompose = (scope: string, historyId: number | null, entry: ComposeEntry, remember = false) => {
  const key = mobileComposeKey(scope, historyId);
  entries.set(key, entry);
  if (remember) latest.set(scope, historyId);
  listeners.get(key)?.forEach((listener) => listener());
};
export const subscribeMobileCompose = (key: string, listener: () => void) => {
  const subscribers = listeners.get(key) ?? new Set();
  subscribers.add(listener);
  listeners.set(key, subscribers);
  return () => {
    subscribers.delete(listener);
    if (!subscribers.size) listeners.delete(key);
  };
};
